module.exports = __webpack_public_path__ + "img/water5-2.bca71325.jpg";